$ = require 'jquery'
Action = require 'models/action'
ActionList = require 'models/collections/action-list'
ActionListView = require 'views/action/action-list-view'
Auth = require 'db/auth'
Backgrounds = require 'data/backgrounds'
BoardSidebarPowerUpSlotView = require 'views/board-menu/board-sidebar-power-up-slot-view'
BusinessClassUpsellView = require 'views/directory/business-class-upsell-view'
ClientConfig = require 'debug/client-config'
PopOver = require 'views/lib/pop-over'
Storage = require 'lib/storage'
Util = require 'lib/util'
View = require 'view'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
templates = require 'views/internal/templates'
boardMenuTemplate = require 'views/templates/board_menu_default'
boardMenuPowerUpSlotTemplate = require 'views/templates/board_menu_power_up_slot'
Promise = require 'bluebird'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
simpleTest = require 'lib/experiments/simple-test'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
l = require 'lib/localize'
localizeCount = require 'lib/localize-count'
formatNumber = require 'lib/format/number'
logError = require 'debug/log-error'
mixin = require 'lib/mixin'
ViewWithActions = require 'views/internal/view-with-actions'
LatestPowerUpsMessage = require 'data/latest-power-ups-message'
ClientConfig = require 'debug/client-config'
PluginRunner = require 'views/internal/plugins/plugin-runner'

module.exports = class BoardSidebarDefaultView extends View
  mixin ViewWithActions, @
  viewTitleKey: 'menu'

  viewIcon: 'member'

  className: 'board-menu-content-frame'

  headerDisplayTypeClass: 'is-board-menu-default-view'

  initialize: ({ @sidebarView }) ->

    @numActionsToShow = 15

    @makeDebouncedMethods 'render', 'renderMembers', 'renderPowerUpSlots'

    @listenTo @model,
      'change:datePluginDisable': @renderPowerUpDisableTimer
      'change:prefs.permissionLevel': @renderDebounced
      'change:powerUps': @renderEnabledPowerUpCount
      'change:idOrganization': @renderPowerUpSlotsDebounced

    @listenTo @model.boardPluginList,
      'add remove reset': (e) =>
        @renderEnabledPowerUpCount()
        @renderPowerUpSlotsDebounced()

    @subscribe pluginsChangedSignal(@model), =>
      @renderEnabledPowerUpCount()
      @renderPowerUpSlotsDebounced()

    @actionListView = @collectionSubview ActionListView, new ActionList([], { @modelCache }),
      renderOpts:
        limit: @numActionsToShow
        context: @model
        compact: true
        truncateComments: (action) =>
          action.get('date') < @model.get('dateLastView')
        excludeTypes: ['copyCommentCard']

    @waitForId @model, =>
      @listenTo @modelCache, "add:Action:#{ @model.id } remove:Action:#{ @model.id } change:Action:#{ @model.id }", @frameDebounce =>
        @renderActionCount()
        @actionListView.collection.reset(@getActions())

      @actionListView.collection.reset(@getActions())

  events:
    'click .js-change-background': 'changeBackground'
    'click .js-open-power-ups': 'showPowerUps'
    'click .js-open-stickers': 'openStickers'
    'click .js-open-card-filter': 'showCardFilter'
    'click .js-open-activity': 'openActivity'
    'click .js-open-more': 'openMore'
    'click .js-power-up-empty-slot': 'showPowerUps'
    'click .js-power-up-slot-upsell': 'toggleBusinessClassUpsell'

  render: ->
    me = Auth.me()

    data =
      editable: @model.editable()
      hasBCPowerUps: me.hasBCPowerUps()
      hasGoldPowerUps: me.isFeatureEnabled('threePlugins')
      inPowerUpSlotsExperiment: simpleTest('powerUpSlots').get('enabled')

    @$el.html(boardMenuTemplate(data))

    @actionListView.setElement(@$('.js-menu-action-list')[0])
    @renderActions()
    @renderActionCount()
    @renderEnabledPowerUpCount()
    @renderBackgroundPreview()
    @renderPowerUpDisableTimer()
    @renderPowerUpSlots()

    @

  renderBackgroundPreview: ->
    $preview = @$('.js-fill-background-preview').css
      'background-image': ''
      'background-color': ''

    if Backgrounds[@model.getPref('background')]?.tile?
      backgroundImageUrl = @model.getPref('backgroundImage')
    else if @model.getPref('backgroundImageScaled')? || @model.getPref('backgroundImage')?
      backgroundImageUrl =
        Util.previewBetween(@model.getPref('backgroundImageScaled'), 90, 60, 600, 400)?.url ?
        @model.get('fullSizeUrl') ?
        @model.getPref('backgroundImage')

    else if @model.getPref('backgroundColor')?
      backgroundColor = @model.getClientBackgroundColor @model.getPref('background')
    else
      backgroundColor = @model.getClientBackgroundColor "blue"

    $preview.css
      'background-image':
        if backgroundImageUrl
          "url(#{backgroundImageUrl})"
        else
          ''
      'background-color': backgroundColor

    @

  getDateLastViewedActionsStorageKey: ->
    if @model.id
      "timeLastViewedActions-#{@model.id}"
    else
      null

  setDateLastViewedActions: (date) ->
    if (key = @getDateLastViewedActionsStorageKey())?
      Storage.set key, date.toISOString()
    return

  setDateLastViewedActionsAsNow: ->
    @setDateLastViewedActions new Date()
    return

  getDateLastViewedActions: ->
    if (key = @getDateLastViewedActionsStorageKey())?
      if (isoString = Storage.get key)?
        return new Date(isoString)
    null

  renderActionCount: ->
    @$('.js-unread-activity-count').empty()

    dateSince = @getDateLastViewedActions()
    maxNumber = 50

    if !dateSince?
      dateSince = new Date()
      @setDateLastViewedActions(dateSince)

    isCountable = (action) =>
      isNew = new Date(action.get('date')) > dateSince
      isNotMe = action.get('idMemberCreator') != Auth.me().id
      isNew && isNotMe

    count = 0
    for action in @model.getActions()
      if isCountable(action)
        count++

    # we show some comments on the top view which we consider viewed.
    # don't set the actions as viewed if it's 0, because…
    #   1. renderActionCount could have been called before actions were
    #   returned, and we don't want to erroneously set the time and ruin the
    #   count.
    #   2. it's not doing anything anyway
    if 0 < count <= @numActionsToShow
      @setDateLastViewedActionsAsNow()

    countText = count
    if count >= maxNumber
      countText = "#{maxNumber}+"

    if count > @numActionsToShow
      @$('.js-unread-activity-count').text countText

    data =
      count: countText
      hasCount: count > @numActionsToShow

    @$('.js-fill-activity-button').empty().append(
      templates.fill(
        'board_menu_more_activity_button'
        data
      )
    )

    @

  renderPowerUpDisableTimer: ->
    daysRemaining = @model.daysUntilPluginsDisable()
    if daysRemaining != null
      @$('.js-power-up-disable-timer')
        .removeClass('hide')
        .text(localizeCount 'days remaining', daysRemaining)
    else
      @$('.js-power-up-disable-timer').addClass('hide')

  getEnabledPowerUpCount: ->
    @model.get('powerUps').length + @model.boardPluginList.length

  renderEnabledPowerUpCount: ->
    # Show the new banner for the "one power-up for all teams launch"
    me = Auth.me()
    showNew = me && LatestPowerUpsMessage && !me.isDismissed(LatestPowerUpsMessage)

    if showNew
      @$('.js-enabled-power-up-count').text('')
      @$('.js-power-up-new').removeClass('hide')
    else
      @$('.js-power-up-new').addClass('hide')

      count = @getEnabledPowerUpCount()
      if count > 0
        @$('.js-enabled-power-up-count').text(formatNumber(count))
      else
        @$('.js-enabled-power-up-count').text('')
    @

  renderActions: ->
    @actionListView.render()
    @

  showPowerUps: (e) ->
    Util.stop(e)
    me = Auth.me()
    if me && LatestPowerUpsMessage && !me.isDismissed(LatestPowerUpsMessage)
      me.dismiss(LatestPowerUpsMessage)

    @sidebarView.boardView.toggleDirectory()

    if !@sidebarView.boardView.directoryView
      if @$(e.target).hasClass('js-power-up-empty-slot')
        ref = 'empty Power-Up slot'
      else
        ref = 'Power-Ups button'

      trackUe('board view', 'opens', 'Power-Up directory home page', '', '', "by clicking #{ref} in sidebar")

    daysRemaining = @model.daysUntilPluginsDisable()
    if daysRemaining != null
      track('Board Menu', 'Open Power-Ups', 'Power-Ups Timer Active')
    else
      track("Board Menu", "Open Power-Ups")
    return

  showCardFilter: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'filter'
    track("Board Menu", "Open Card Filter Menu")
    return

  openStickers: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'stickers'
    track("Board Menu", "Open Stickers", "Via Default Menu")
    return

  changeBackground: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'background'
    track("Board Menu", "Open Change Background")
    return

  openActivity: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'activity'
    @setDateLastViewedActionsAsNow()
    track("Board Menu", "View All Board Activity")
    return

  openMore: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'more'
    track("Board Menu", "More Menu")
    return

  remove: ->
    @setDateLastViewedActionsAsNow()
    super

  toggleBusinessClassUpsell: (e) ->
    Util.stop(e)
    PopOver.toggle
      autoPosition: true
      hideHeader: true
      elem: e.target
      view: new BusinessClassUpsellView({ @model })
      displayType: 'directory-business-class-popover'

    if PopOver.isVisible
      trackUe('board view', 'opens', 'Power-Up BC upgrade popover ad', '', '', 'by clicking the unlock more Power-Ups button')

  renderPowerUpSlots: ->
    if @model.editable() && simpleTest('powerUpSlots').get('enabled')
      $powerUpSlotsContainer = @$('.js-power-up-slots')
      $powerUpSlotUpsellContainer = @$('.js-power-up-upsell-slots')
      Promise.map @model.boardPluginList.models, (boardPlugin) =>
        PluginRunner.getOrLoadPlugin(@model, boardPlugin.get('idPlugin'))
      .map (plugin) =>
        @subview(BoardSidebarPowerUpSlotView, @model, {
          plugin
          currentPage: 'board view'
        }, plugin.id)
      .then (subviews) =>
        @ensureSubviews(subviews, $powerUpSlotsContainer)
      .catch (err) ->
        console?.error('Failed to load Power-Ups for board menu.', {
          error: err.message
        })
      .finally =>
        $powerUpSlotUpsellContainer.empty()

        if @model.canEnableAdditionalPowerUps()
          me = Auth.me()
          powerUpsCount = @model.powerUpsCount()
          numberOfEmptySlots = 1

          if me.isFeatureEnabled('threePlugins')
            numberOfEmptySlots = 3 - powerUpsCount

          if me.hasBCPowerUps()
            if powerUpsCount < 3
              numberOfEmptySlots = 3 - powerUpsCount
            else
              numberOfEmptySlots = 1

          _.times numberOfEmptySlots, ->
            $powerUpSlotUpsellContainer.append(boardMenuPowerUpSlotTemplate.emptySlot())
        else if !ClientConfig.get('dontUpsell')
          $powerUpSlotUpsellContainer.append(boardMenuPowerUpSlotTemplate.upsellSlot())



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-sidebar-default-view.coffee